import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "../models/user";
import {DashboardStats} from "../models/stats/dashboard-stats";
import {DashboardData} from "../models/stats/dashboard-data";
import {ServerEndpoints} from "../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class GeneralHttpService {
  private _baseUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject('BASE_HEADERS') baseHeaders: HttpHeaders,) {
    this._baseUrl = baseUrl;

  }

  online() {
    return this.http.get(this._baseUrl + ServerEndpoints.Inventory_General_OnlineCheck)
  }

  login(name: string, password: string): Observable<User> {
    return this.http.post<User>(this._baseUrl + "/auth/User/Login", {
      "Name": name,
      "Password": password
    });
  }

  logout(jwt: string): Observable<any> {
    return this.http.post(this._baseUrl + "/auth/User/Logout?jwt=" + jwt, {});
  }


  getDashboardStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(this._baseUrl + ServerEndpoints.Inventory_General_GetDashboardStats);
  }

  /**
   * Aggregated, non-sensitive dashboard payload (counts + live/upcoming/past events). Gated server-side to
   * management users (ShardAdmin/CompanyOwner/PlatformOwner) — employees receive a 403.
   */
  getDashboardData(): Observable<DashboardData> {
    return this.http.get<DashboardData>(this._baseUrl + ServerEndpoints.Inventory_General_GetDashboardData);
  }
}
